async function dialogsCarrello() {
  // Selettori DOM iniziali - potrebbero non esistere su tutte le pagine
  const campionciniForm = document.querySelector('[data-campioncini-form]')
  const campioniciniLimitPlaceholder = document.querySelectorAll('[data-campioncini-limit]')
  const giftboxForm = document.querySelector('[data-giftbox-form]')

  /**
   * Recupera i dati del carrello via AJAX
   * @returns {Promise<Object>} Oggetto con dati del carrello (items, total_price, etc.)
   */
  async function getCart() {
    const cartContent = await fetch(window.Shopify.routes.root + 'cart.js').then(res => res.json())
    return cartContent
  }

  /**
   * Filtra e restituisce solo i prodotti campioncini presenti nel carrello
   * Effettua chiamate API per ogni prodotto per ottenere i tags
   * @param {Array} cartItems - Array degli items del carrello
   * @returns {Promise<Array>} Array dei prodotti campioncini nel carrello
   */
  async function campionciniNelCarrello(cartItems) {
    // Crea array di Promise per recuperare i dati completi di ogni prodotto
    const cartFullItems = cartItems.map(({handle}) => fetch(`${window.Shopify.routes.root}products/${handle}.js`).then(res => res.json()))
    // Filtra solo i prodotti che hanno il tag 'campioncino'
    const campioncini = (await Promise.all(cartFullItems)).filter(prod => prod.tags.includes('campioncino'))
    return campioncini
  }

  /**
   * Calcola il numero massimo di campioncini gratuiti in base al totale del carrello
   * Scala di limiti:
   * - Fino a 39€: 2 campioncini
   * - Fino a 59€: 3 campioncini  
   * - Fino a 79€: 4 campioncini
   * - Oltre 79€: 5 campioncini
   * @param {number} cartAmount - Totale del carrello in centesimi
   * @returns {number} Numero massimo di campioncini consentiti
   */
  function maxCampioncini(cartAmount) {
    if (cartAmount <= 3900) return 2;
    if (cartAmount <= 5900) return 3;
    if (cartAmount <= 7900) return 4;
    return 5;
  }

  /**
   * Preseleziona automaticamente i checkbox dei campioncini già presenti nel carrello
   * Utile per mostrare all'utente cosa ha già scelto
   * @param {Array} campionciniInseriti - Array dei campioncini già nel carrello
   */
  function preselezionaCampioncini(campionciniInseriti) {
    // Estrae gli ID delle varianti dei campioncini nel carrello
    const campionciniInseritiVariantID = campionciniInseriti.map(prod => prod.variants[0].id)
    // Trova i checkbox corrispondenti e li seleziona
    const opzioniDaSelezionare = [...campionciniForm.querySelectorAll('input[type="checkbox"]')].filter(cb => campionciniInseritiVariantID.includes(+cb.value))
    opzioniDaSelezionare.forEach(cb => cb.checked = true)
  }

  /**
   * Gestisce il comportamento dinamico dei checkbox dei campioncini
   * - Aggiorna il contatore dei campioncini selezionati
   * - Disabilita le opzioni quando si raggiunge il limite massimo
   * - Riabilita le opzioni quando si scende sotto il limite
   * @param {number} maxCampioncini - Numero massimo di campioncini consentiti
   */
  function opzioniCampionciniChangeHandler(maxCampioncini) {
    const campionciniSelezionati = campionciniForm.querySelectorAll('input[type="checkbox"]:checked')
    const numSelectedPlaceholder = document.querySelector('[data-campioncini-selected]')
    
    // Aggiorna il contatore visuale
    numSelectedPlaceholder.innerHTML = campionciniSelezionati.length
    
    // Gestisce l'abilitazione/disabilitazione dei checkbox in base al limite
    if (campionciniSelezionati.length >= maxCampioncini) {
      // Disabilita tutti i checkbox non selezionati
      campionciniForm.querySelectorAll('input[type="checkbox"]:not(:checked)').forEach(cb => cb.disabled = true)
    } else {
      // Riabilita tutti i checkbox non selezionati
      campionciniForm.querySelectorAll('input[type="checkbox"]:not(:checked)').forEach(cb => cb.disabled = false)
    }
  }

  /**
   * Aggiorna l'interfaccia del carrello senza ricaricare la pagina
   * Usa la stessa logica del tema per aggiornare le sezioni del cart drawer
   */
  async function updateCartUI() {
    try {
      // Definisce le sezioni da aggiornare (stessa logica di cart.js)
      const cartDrawer = document.querySelector('cart-drawer')
      let sectionsToRender = []

      if (cartDrawer) {
        const mainCartId = document.getElementById('main-cart-items')?.dataset.id
        if (mainCartId) {
          sectionsToRender = [
            { id: `#shopify-section-${mainCartId}`, section: mainCartId, selector: `#shopify-section-${mainCartId} cart-items` },
            { id: "#cart-counter", section: "cart-counter", selector: "#shopify-section-cart-counter" },
            { id: "#CartDrawer-Body", section: "cart-drawer", selector: "#shopify-section-cart-drawer #CartDrawer-Body" }
          ]
        } else {
          sectionsToRender = [
            { id: "#CartDrawer-Body", section: "cart-drawer", selector: "#shopify-section-cart-drawer #CartDrawer-Body" }
          ]
        }
      } else {
        const mainCartId = document.getElementById('main-cart-items')?.dataset.id
        if (mainCartId) {
          sectionsToRender = [
            { id: `#shopify-section-${mainCartId}`, section: mainCartId, selector: `#shopify-section-${mainCartId} cart-items` },
            { id: '#cart-counter', section: 'cart-counter', selector: '#shopify-section-cart-counter' }
          ]
        }
      }

      // Richiede le sezioni aggiornate dal server
      const body = JSON.stringify({
        sections: sectionsToRender.map(section => section.section),
        sections_url: window.location.pathname
      })

      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: body
      })

      const parsedState = await response.json()

      // Aggiorna ogni sezione con il nuovo HTML
      sectionsToRender.forEach(section => {
        const elementToReplace = document.querySelector(section.selector) || document.querySelector(section.id)
        
        if (elementToReplace && parsedState.sections && parsedState.sections[section.section]) {
          elementToReplace.innerHTML = getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          )
        }
      })

      // Aggiorna contatori aggiuntivi
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = parsedState.item_count
      })

      // Trigger evento personalizzato
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: parsedState }))
      
      return parsedState
    } catch (error) {
      console.error('Errore durante l\'aggiornamento UI del carrello:', error)
      throw error
    }
  }

  /**
   * Estrae l'HTML interno di una sezione (helper function)
   */
  function getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  /**
   * Aggiorna il contenuto del dialog dei campioncini con le nuove selezioni
   * Ricarica i dati del carrello e aggiorna le checkbox preselezionate
   */
  async function updateDialogContent() {
    try {
      // Ottiene i dati aggiornati del carrello
      const { total_price: newTotalPrice, items: newCartItems } = await getCart()
      
      // Identifica i nuovi campioncini nel carrello
      const newCampionciniInseriti = await campionciniNelCarrello(newCartItems)
      
      // Calcola il nuovo limite di campioncini
      const newCampionciniLimit = maxCampioncini(newTotalPrice)
      
      // Aggiorna il limite visualizzato nel dialog
      document.querySelectorAll('[data-campioncini-limit]').forEach(el => {
        el.innerHTML = newCampionciniLimit
      })
      
      // Reset di tutte le checkbox
      if (campionciniForm) {
        campionciniForm.querySelectorAll('input[type="checkbox"]').forEach(cb => {
          cb.checked = false
          cb.disabled = false
        })
      }
      
      // Preseleziona i nuovi campioncini nel carrello
      if (campionciniForm && newCampionciniInseriti.length > 0) {
        preselezionaCampioncini(newCampionciniInseriti)
        opzioniCampionciniChangeHandler(newCampionciniLimit)
      }
      
      // Aggiorna le variabili globali per la prossima operazione
      campionciniInseriti.length = 0
      campionciniInseriti.push(...newCampionciniInseriti)
      
      console.log('Dialog aggiornato con i nuovi campioncini')
      
    } catch (error) {
      console.error('Errore durante l\'aggiornamento del dialog:', error)
      throw error
    }
  }

  /**
   * Gestisce il submit del form dei campioncini
   * 1. Rimuove i campioncini esistenti dal carrello
   * 2. Aggiunge i nuovi campioncini selezionati
   * 3. Aggiorna l'interfaccia senza ricaricare la pagina
   * @param {Event} e - Evento di submit del form
   */
  async function submitSamplesForm(e) {
    e.preventDefault()

    // Controllo per evitare click multipli
    const submitButton = e.target.querySelector('[type="submit"]')
    if (submitButton.disabled) {
      return // Se il button è già disabilitato, esci
    }
    
    // Disabilita il button e cambia il testo
    submitButton.disabled = true
    const originalText = submitButton.textContent
    submitButton.textContent = 'Loading...'
    
    try {
      // Estrae gli ID delle varianti dei campioncini selezionati
      const idCampionciniSelezionati = [...e.target.querySelectorAll('[type="checkbox"]:checked')].map(cb => cb.value)
      
      // Rimuove i campioncini esistenti se presenti
      campionciniInseriti.length > 0 && await removeCampionciniFromCart()
      
      // Aggiunge i nuovi campioncini e aggiorna l'interfaccia senza reload
      await addItemsSelezionati(idCampionciniSelezionati)
      await updateCartUI()
      
      // Riabilita il button dopo il successo
      submitButton.disabled = false
      submitButton.textContent = originalText
      
      // Aggiorna il dialog con i nuovi campioncini invece di chiuderlo
      await updateDialogContent()
      
      console.log('Campioncini aggiunti con successo al carrello!')
      
      // Chiude il dialog triggerando il click sul bottone di chiusura
      const closeButton = document.querySelector('[js-close-samples]')
      if (closeButton) {
        closeButton.click()
      }
      
    } catch (error) {
      console.error('Errore durante il submit:', error)
      
      // Riabilita il button in caso di errore
      submitButton.disabled = false
      submitButton.textContent = originalText
      
      // Mostra messaggio di errore se necessario
      const errorDialog = document.querySelector('[data-campioncini-message]')
      if (errorDialog) {
        errorDialog.classList.add('is-open')
      }
    }
  }

  /**
   * Rimuove tutti i campioncini attualmente presenti nel carrello
   * Utilizza l'API cart/update.js di Shopify impostando quantity = 0
   * @returns {Promise<Object>} Risposta dell'API Shopify
   */
  async function removeCampionciniFromCart() {
    // Crea payload per impostare quantity = 0 per ogni campioncino
    const payload = campionciniInseriti.reduce((acc, curr) => {
      acc.updates[curr.variants[0].id] = 0
      return acc
    }, { updates: {} })
    
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(res => res.json())
  }

  /**
   * Aggiunge al carrello un array di prodotti con quantity = 1
   * Utilizza l'API cart/add.js di Shopify per aggiungere multipli prodotti
   * @param {Array} idArray - Array di ID delle varianti da aggiungere
   * @returns {Promise<Object>} Risposta dell'API Shopify
   */
  async function addItemsSelezionati(idArray) {
    // Crea payload per aggiungere ogni variante con quantity = 1
    const payload = idArray.reduce((acc, curr) => {
      acc.items.push({id: parseInt(curr), quantity: 1})
      return acc
    }, { items: [] })

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(res => res.json())
  }

  /**
   * Blocca il processo di checkout quando ci sono troppi campioncini nel carrello
   * 1. Mostra un messaggio di errore
   * 2. Sostituisce il bottone di checkout con uno che mostra l'errore
   * Previene l'acquisto fino a quando l'utente non corregge il problema
   */
  function blockCart() {
    const messageModal = document.querySelector('[data-campioncini-message]')

    // Mostra immediatamente il messaggio di errore
    messageModal && messageModal.classList.add('is-open');
    
    // Polling per trovare e sostituire il bottone di checkout
    const interval = setInterval(() => {
      const cartForm = document.querySelector('form.cart-with-samples')
      const checkoutBtn = cartForm.querySelector('[type="submit"]')
      
      // Controlla se il bottone ha l'attributo specifico (probabilmente aggiunto da altro codice)
      if (checkoutBtn.hasAttribute('data-saso')) {
        clearInterval(interval)
        
        // Crea un bottone fake che mostra l'errore invece di procedere al checkout
        const fakeBtn = document.createElement('a')
        fakeBtn.classList.add('Cart__Checkout', 'Button', 'Button--primary')
        fakeBtn.textContent = checkoutBtn.textContent
        fakeBtn.style.cursor = 'pointer'
        fakeBtn.style.margin = '0'
        
        // Il click sul bottone fake mostra il messaggio di errore
        fakeBtn.addEventListener('click', _e => {
          messageModal.querySelector('[data-campioncini-limit]') && (messageModal.querySelector('[data-campioncini-limit]').textContent = campionciniLimit)
          messageModal && messageModal.classList.add('is-open');
        })

        // Sostituisce il bottone originale con quello fake
        checkoutBtn.parentElement.append(fakeBtn)
        checkoutBtn.remove()
      }else{
        checkoutBtn.disabled = true
        checkoutBtn.style.cursor = 'not-allowed'
      }
    }, 500)
  }

  /**
   * Preseleziona automaticamente i checkbox delle gift box già presenti nel carrello
   * Simile a preselezionaCampioncini ma per le gift box
   * @param {Array} boxesInCart - Array delle gift box già nel carrello
   */
  function preselezionaGiftbox(boxesInCart) {
    // Estrae gli ID delle varianti delle gift box nel carrello
    const boxesInCartVariantID = boxesInCart.map(item => item.id)
    // Trova i checkbox corrispondenti e li seleziona
    const opzioniDaSelezionare = [...giftboxForm.querySelectorAll('input[type="checkbox"]')].filter(cb => boxesInCartVariantID.includes(+cb.value))
    opzioniDaSelezionare.forEach(cb => cb.checked = true)
  }

  /**
   * Gestisce il submit del form delle gift box
   * Processo simile ai campioncini: rimuove esistenti, aggiunge nuovi, aggiorna UI
   * @param {Event} e - Evento di submit del form
   */
  async function submitGiftboxForm(e) {
    e.preventDefault()
    
    const submitButton = e.target.querySelector('[type="submit"]')
    if (submitButton && submitButton.disabled) {
      return
    }
    
    if (submitButton) {
      submitButton.disabled = true
      const originalText = submitButton.textContent
      submitButton.textContent = 'Loading...'
    }
    
    try {
      // Estrae gli ID delle gift box selezionate
      const idGiftboxSelezionati = [...e.target.querySelectorAll('[type="checkbox"]:checked')].map(cb => cb.value)
      
      // Rimuove le gift box esistenti se presenti
      if (boxesInCart.length > 0) {
        await removeGiftboxFromCart()
      }
      
      // Aggiunge le nuove gift box
      await addItemsSelezionati(idGiftboxSelezionati)
      
      // Aggiorna l'interfaccia senza reload
      await updateCartUI()
      
      // Riabilita il button dopo il successo
      if (submitButton) {
        submitButton.disabled = false
        submitButton.textContent = originalText
      }
      
      // Chiude il dialog
      const dialog = e.target.closest('dialog')
      if (dialog) {
        dialog.close()
      }
      
      console.log('Gift box aggiunte con successo al carrello!')
      
    } catch (error) {
      console.error('Errore durante il submit gift box:', error)
      
      if (submitButton) {
        submitButton.disabled = false
        submitButton.textContent = originalText
      }
    }
  }

  /**
   * Rimuove tutte le gift box attualmente presenti nel carrello
   * Utilizza l'API cart/update.js di Shopify impostando quantity = 0
   * @returns {Promise<Object>} Risposta dell'API Shopify
   */
  async function removeGiftboxFromCart() {
    // Crea payload per impostare quantity = 0 per ogni gift box
    const payload = boxesInCart.reduce((acc, curr) => {
      acc.updates[curr.id] = 0
      return acc
    }, { updates: {} })
    
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(res => res.json())
  }

  /**
   * INIZIALIZZAZIONE CAMPIONCINI
   * Questa sezione esegue la logica iniziale per gestire i campioncini
   */
  
  // 1. Recupera i dati attuali del carrello
  const { total_price: totalPrice, items: cartItems } = await getCart()

  // 2. Identifica i campioncini già presenti nel carrello
  const campionciniInseriti = await campionciniNelCarrello(cartItems)

  // 3. Calcola il limite massimo di campioncini in base al totale
  const campionciniLimit = maxCampioncini(totalPrice)

  // // 4. Debug: stampa informazioni nel console
  // console.log('campionciniInseriti', campionciniInseriti)
  // console.log('campionciniLimit', campionciniLimit)

  // 5. Aggiorna tutti gli elementi nel DOM che mostrano il limite
  campioniciniLimitPlaceholder.forEach(el => el.innerHTML = campionciniLimit)

  // 6. Preseleziona i campioncini già nel carrello (se esistono)
  campionciniForm && campionciniInseriti.length > 0 && preselezionaCampioncini(campionciniInseriti)

  // 7. Imposta il comportamento dinamico del form campioncini
  campionciniForm && campionciniInseriti.length > 0 && opzioniCampionciniChangeHandler(campionciniLimit)
  // Attacca listener per i cambiamenti dei checkbox
  campionciniForm && campionciniForm.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.addEventListener('change', _e => opzioniCampionciniChangeHandler(campionciniLimit)))

  // 8. Attacca listener per il submit del form campioncini
  campionciniForm && campionciniForm.addEventListener('submit', submitSamplesForm)

  // 9. Blocca il checkout se ci sono troppi campioncini
  campionciniInseriti.length > campionciniLimit && blockCart()

  /**
   * INIZIALIZZAZIONE GIFT BOX
   * Questa sezione gestisce la logica per le gift box
   */
  
  // 1. Estrae gli ID delle varianti disponibili nel form gift box
  const boxesVariantIds = giftboxForm ? [...giftboxForm.querySelectorAll('input[type="checkbox"]')].map(cb => parseInt(cb.value)) : []

  // 2. Identifica le gift box già presenti nel carrello
  const boxesInCart = boxesVariantIds.length > 0 ? cartItems.filter(item => boxesVariantIds.includes(item.id)) : []
  
  // Debug per gift box (commentato)
  //console.log('boxesVariantIds',boxesVariantIds)
  //console.log('cartItems',cartItems);
  //console.log('boxesInCart',boxesInCart);

  // 3. Preseleziona le gift box già nel carrello
  giftboxForm && boxesInCart.length > 0 && preselezionaGiftbox(boxesInCart)

  // 4. Attacca listener per il submit del form gift box
  giftboxForm && giftboxForm.addEventListener('submit', submitGiftboxForm)

  // console.log('Cart update listeners initialized');
  
}

// Esegui al caricamento della pagina
dialogsCarrello();

// Listener per aggiornamenti generici del carrello
document.addEventListener('cart:updated', async function(event) {
  //console.log('Cart updated, re-initializing dialogs...');
  await dialogsCarrello();
});

// Listener per rimozione items specifici
document.addEventListener('cart:item-removed', async function(event) {
  //console.log('Cart item removed, re-initializing dialogs...');
  await dialogsCarrello();
});
